// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__pnBtz","error":"Notification_error__gfj5t","success":"Notification_success__CErX+"};